import {
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  Signal,
} from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { ESiteContext, ICorporateDesign } from '@web/dtos';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import {
  ButtonGroupComponent,
  IButtonOption,
} from '../../data-input/form-inputs/button-group/button-group.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SiteContextService } from '../../../services/site-context/site-context.service';

@Component({
  selector: 'aw-button-display',
  imports: [ButtonComponent, ButtonGroupComponent, ReactiveFormsModule],
  templateUrl: './button-display.component.html',
})
export class ButtonDisplayComponent implements OnDestroy {
  protected corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly siteContextService: SiteContextService =
    inject(SiteContextService);
  public corporateDesign: Signal<ICorporateDesign | undefined> =
    this.corporateDesignService.corporateDesign;

  public buttonGroup: IButtonOption<number>[] = this.createOptions(11);
  public buttonControl: FormControl<any> = new FormControl();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnDestroy() {
    this.siteContextService.setContext(ESiteContext.Shop);
  }

  toggleContext(): void {
    this.siteContextService.toggleContext();
    this.cdr.detectChanges();
  }

  private createOptions(n: number): IButtonOption<number>[] {
    return new Array(n).fill(0).map((value, index) => {
      return {
        label: 'Button ' + index + 1,
        value: index,
      };
    });
  }
}
